const flatInfo = [{
    id:1,
    longitude: 90.6125,
    latitude: 23.8110,
    title: "Luxury Apartment in Downtown",
    subtitle: "Spacious 3-bedroom apartment with modern amenities",
    additionals: [
      { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
      { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
      // { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
      // { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
    ],
    imageSources: [
      "https://placehold.co/500x500",
      "https://placehold.co/500x500"
    ],
    tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
    specialOffer: "Get 1 month free if booked before March 1st!",
    description: "This luxury apartment offers a prime location...",
    openHours: [
      { day: "Monday", time: "9 AM - 5 PM" },
      { day: "Saturday", time: "10 AM - 3 PM" }
    ],
    costBreakdown: {
      main: {
        oneTime: {
          required: [
            { description: "Security Deposit", value: 500 },
            { description: "Security Deposit", value: 500 },
            { description: "Security Deposit", value: 500 },
            { description: "First Month Rent", value: 1200 }
          ],
          optional: [
            { description: "Parking Fee", value: 100 }
          ]
        },
        monthly: {
          required: [
            { description: "Rent", value: 12000 },
            { description: "Maintenance", value: 50 }
          ],
          optional: [
            { description: "Gym Membership", value: 30 }
          ]
        }
      },
      additionals: {
        oneTime: {
          required: [],
          optional: []
        },
        monthly: {
          required: [],
          optional: []
        }
      }
    }
},

{
  id:2,
  longitude: 90.4125,
  latitude: 23.9120,
  title: "Luxury Apartment in Downtown",
  subtitle: "Spacious 3-bedroom apartment with modern amenities",
  additionals: [
    { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
  ],
  imageSources: [
    "/flat2.png",
    "/flat1.jpg"
  ],
  tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
  specialOffer: "Get 1 month free if booked before March 1st!",
  description: "This luxury apartment offers a prime location...",
  openHours: [
    { day: "Monday", time: "9 AM - 5 PM" },
    { day: "Saturday", time: "10 AM - 3 PM" }
  ],
  costBreakdown: {
    main: {
      oneTime: {
        required: [
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "First Month Rent", value: 1200 }
        ],
        optional: [
          { description: "Parking Fee", value: 100 }
        ]
      },
      monthly: {
        required: [
          { description: "Rent", value: 22000 },
          { description: "Maintenance", value: 50 }
        ],
        optional: [
          { description: "Gym Membership", value: 30 }
        ]
      }
    },
    additionals: {
      oneTime: {
        required: [],
        optional: []
      },
      monthly: {
        required: [],
        optional: []
      }
    }
  }
},

{
  id:3, 
  longitude: 90.4125,
  latitude: 23.9103,
  title: "Luxury Apartment in Downtown",
  subtitle: "Spacious 3-bedroom apartment with modern amenities",
  additionals: [
    { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
  ],
  imageSources: [
    "/Hero.jpg",
    "/hero2.jpg"
  ],
  tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
  specialOffer: "Get 1 month free if booked before March 1st!",
  description: "This luxury apartment offers a prime location...",
  openHours: [
    { day: "Monday", time: "9 AM - 5 PM" },
    { day: "Saturday", time: "10 AM - 3 PM" }
  ],
  costBreakdown: {
    main: {
      oneTime: {
        required: [
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "First Month Rent", value: 1200 }
        ],
        optional: [
          { description: "Parking Fee", value: 100 }
        ]
      },
      monthly: {
        required: [
          { description: "Rent", value: 32000 },
          { description: "Maintenance", value: 50 }
        ],
        optional: [
          { description: "Gym Membership", value: 30 }
        ]
      }
    },
    additionals: {
      oneTime: {
        required: [],
        optional: []
      },
      monthly: {
        required: [],
        optional: []
      }
    }
  }
},


{
  id:4 ,
  longitude: 90.4125,
  latitude: 24.0103,
  title: "Luxury Apartment in Downtown",
  subtitle: "Spacious 3-bedroom apartment with modern amenities",
  additionals: [
    { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
  ],
  imageSources: [
    "/hero2.jpg",
    "/floor4.jpg"
  ],
  tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
  specialOffer: "Get 1 month free if booked before March 1st!",
  description: "This luxury apartment offers a prime location...",
  openHours: [
    { day: "Monday", time: "9 AM - 5 PM" },
    { day: "Saturday", time: "10 AM - 3 PM" }
  ],
  costBreakdown: {
    main: {
      oneTime: {
        required: [
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "First Month Rent", value: 1200 }
        ],
        optional: [
          { description: "Parking Fee", value: 100 }
        ]
      },
      monthly: {
        required: [
          { description: "Rent", value: 42000 },
          { description: "Maintenance", value: 50 }
        ],
        optional: [
          { description: "Gym Membership", value: 30 }
        ]
      }
    },
    additionals: {
      oneTime: {
        required: [],
        optional: []
      },
      monthly: {
        required: [],
        optional: []
      }
    }
  }
},

{
  id: 5,
  longitude: 90.4125,
  latitude: 23.7103,
  title: "Luxury Apartment in Downtown",
  subtitle: "Spacious 3-bedroom apartment with modern amenities",
  additionals: [
    { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
  ],
  imageSources: [
    "/flat5.jpg",
    "/flat6.jpg"
  ],
  tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
  specialOffer: "Get 1 month free if booked before March 1st!",
  description: "This luxury apartment offers a prime location...",
  openHours: [
    { day: "Monday", time: "9 AM - 5 PM" },
    { day: "Saturday", time: "10 AM - 3 PM" }
  ],
  costBreakdown: {
    main: {
      oneTime: {
        required: [
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "First Month Rent", value: 1200 }
        ],
        optional: [
          { description: "Parking Fee", value: 100 }
        ]
      },
      monthly: {
        required: [
          { description: "Rent", value: 52000 },
          { description: "Maintenance", value: 50 }
        ],
        optional: [
          { description: "Gym Membership", value: 30 }
        ]
      }
    },
    additionals: {
      oneTime: {
        required: [],
        optional: []
      },
      monthly: {
        required: [],
        optional: []
      }
    }
  }
},

{
  id: 6,
  longitude: 90.4125,
  latitude: 23.6103,
  title: "Luxury Apartment in Downtown",
  subtitle: "Spacious 3-bedroom apartment with modern amenities",
  additionals: [
    { roomDetails: "3 Bedrooms, 2 Bathrooms , a big brown fox jumps over a lazy dog", additionalValue: "18,500 tk", availableCount: 2 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 },
    { roomDetails: "1 Living Room, 1 Kitchen", additionalValue: "3,400 tk", availableCount: 1 }
  ],
  imageSources: [
    "/flat3.webp",
    "/flat7.jpg"
  ],
  tags: ["Central Generator", "Pet Friendly", "Swimming Pool"],
  specialOffer: "Get 1 month free if booked before March 1st!",
  description: "This luxury apartment offers a prime location...",
  openHours: [
    { day: "Monday", time: "9 AM - 5 PM" },
    { day: "Saturday", time: "10 AM - 3 PM" }
  ],
  costBreakdown: {
    main: {
      oneTime: {
        required: [
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "Security Deposit", value: 500 },
          { description: "First Month Rent", value: 1200 }
        ],
        optional: [
          { description: "Parking Fee", value: 100 }
        ]
      },
      monthly: {
        required: [
          { description: "Rent", value: 10000 },
          { description: "Maintenance", value: 50 }
        ],
        optional: [
          { description: "Gym Membership", value: 30 }
        ]
      }
    },
    additionals: {
      oneTime: {
        required: [],
        optional: []
      },
      monthly: {
        required: [],
        optional: []
      }
    }
  }
}
];



export default flatInfo;